<template>
<div>
    <b-navbar toggleable="lg" type="light" variant="light">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item @click="toHomePage">All Products</b-nav-item>
                <b-nav-item v-for="(item, index) in uniqCategory" :key="index"><Category :item="item"/></b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</div>

</template>

<script>
import Category from './Category'
export default {
  name: 'NavbarCategory',
  data () {
    return {
      category: [],
      uniqCategory: this.getuniqCategory
    }
  },
  components: {
    Category
  },
  methods: {
    getproducts () {
      return this.$store.dispatch('fetchAllProducts')
    },
    getCategory () {
      this.$store.state.products.forEach(product => {
        this.category.push(product.Category.name)
      })
    },
    getuniqCategory () {
      const newArray = [...new Set(this.category)]
      this.uniqCategory = newArray
    },
    toHomePage () {
      this.$router.push({ name: 'Home' })
    }
  },
  created () {
    this.getproducts()
    this.getCategory()
    this.getuniqCategory()
  }
}
</script>

<style>

</style>
